;$(document).ready(function(){	
	responsiveNav(".nav-collapse");
	resizeAllGridItems();
});

$(window).resize(function() {
	resizeAllGridItems();
});